export const LINKEDIN = 'Linkedin';
export const FACEBOOK = 'Facebook';

const socialNetworkConfig = {
    [LINKEDIN]: {
        networkUrl: 'https://www.linkedin.com/shareArticle?mini=true&url=',
    },
    [FACEBOOK]: {
        networkUrl: 'http://www.facebook.com/share.php?u=',
    },
};

export const shareOnSocialNetwork = (network, link) => {
    const { networkUrl } = socialNetworkConfig[network];
    const encodedLink = encodeURI(link);
    const url = `${networkUrl}${encodedLink}`;
    window.open(
        url,
        'share',
        '_blank, width=700, height=700, resizable=yes, scrollbars=yes, left=50px, top=50px',
    );

    return false;
};
